import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    next: "Next",
    previous: "PREVIOUS",
    view: "View",
    back: "Back",
    enterbusiness: "Please Enter Your Business Type",
    searchEmpIDFullEmailPosition: "Search ........",
    searchcompanyname: "Search Company Name",
    CompanyAddressRequired: "Company Address is required",
    Emailrequired: "E-mail is required",
    CompanyAddress: "Company Address",
    CompanyTelephoneNo: "Company telephone No",
    searchnameusername: "Search Company name/username",
    companyNotChecked: "Company not checked in for one month or more",
    lastCheckInDate: "Last Check In Date",
    numberofStaff: "Number of Staff",
    CheckInReport: "Check In Report",
    CheckInTime: "Check In Time",
    CheckInUID: "Check In UID",
    CheckInDeviceModel: "Check In Device Model",
    CheckOutTime: "Check Out Time",
    CheckOutUID: "Check Out UID",
    CheckOutDeviceModel: "Check Out Device Model",
    AbnormalReport: "Abnormal Report",
    company_status: "Company Status",
    all_version: "All Version",
    Version_Release: "Version and Release",
    addemployee: "Add Employee",
    announcement: "Announcement",
    admin: "Admin",
    addannouncement: "Add Announcements",
    editannouncement: "Edit Announcements",
    startdatetime: "Start Date Time",
    linkurl: " Link URL",
    enddatetime: "End Date Time",
    row1: "Row 1",
    row2: "Row 2",
    row3: "Row 3",
    lineid: "Line ID",
    facebook: "Facebook",
    customerwec: "Customer web",
    userview: "User view",
    updatepreview: "Update preview",
    updateprevious: "Update Previous",
    showannouncement: "Show Announcement",
    cover: "Cover",
    title: "Title",
    startdate: "Start Date - Time",
    startdates: "Start Date ",
    time: "End Date - Time",
    createdate: "Create Date",
    manage: "Manage",
    usermanagement: "User Management",
    store: "Store",
    article: "Article",
    show: "Show",
    sound: "Sound",
    video: "Video",
    removeannouncement: "Remove Announcement",
    doyouwanttoremovethisannouncement:
      "Do you want to remove this announcement?",
    companymanagement: "Company Management",
    newcompany: "New Company",

    editcompany: "Edit Company",
    companyname: "Company Name",
    companycode: "Company Code",
    viewall: "View All",
    totalEmployee: "Total Employee",
    registrationDate: "Registration Date",
    telephoneno: "Telephone No",
    generalinformation: "General information",
    companyingormation: "Company information",
    saleinformation: "Sale information",
    salename: "Sales name",
    sellingprice: "Selling price",
    pricingplan: "Pricing Plan",
    paymentstatus: "Payment status",
    paymentdate: "Payment date",
    purchaseperiod: "Purchase period",
    additionalfunctions: "Additional functions",
    otheroptionsfields: "Other options fields",
    account: "Account",
    //country: "Country",
    RegistrationHL: "Sign up for a free trial!!​",
    RegistrationHR: "Easy to start with Easy installation",
    RegistrationBL: "Please fill out all fields that must be submitted",
    RegisterCompanyCode:
      "Company or agency abbreviation (in English, no more than 5 characters)",
    RegisterButton: "we accept",
    IsRequired: "is required",
    IsNumber: "  Please fill in Number.",
    IsAlphabet: " Please fill in Alphabet.",
    IsNumberAlaphabet: " Please fill in Alphabet or Number.",
    EnterCorrect: " Please enter correct",
    AlreadyExit: "already exist",
    RegisterSuccessful: "Registration Successful",
    needcompanyname: "Need company name",
    needcompanycode: "Need Company Code",
    needTel: "Need Tel",
    needemail: "Need email",
    needcity: "Need city",
    needcountry: "Please enter country name",
    needaddress: "Need address",
    city: "City",
    contactname: "Contact Name",
    trainingroadmap: "Training RoadMap(ISO)",
    needcontactname: "Need Contact Name",
    address: "Address",
    note: "Note",
    reset: "Reset",
    save: "Save",
    update: "Update",
    status: "Status",
    newemployee: "New Employee",
    editemployee: "Edit Employee",
    employeeinformation: "Employee information",
    profilepicture: "Profile Picture",
    employeeid: "Employee ID",
    companyid: "Company ID",
    fullname: "Full Name",
    email: "Email",
    position: "Position",
    role: "Role",
    type: "Type",
    action: "Action",
    userid: "User ID",
    password: "Password",
    userinformation: "User information",
    logincredentials: "Login credentials",
    resetpassword: "Reset Password",
    doyouwanttoremovethisemployee: "Do you want to remove this Employee?",
    doyouwanttoremovethiscompany: "Do you want to remove this company?",
    removeemployee: "Remove Employee",
    close: "Close",
    remove: "Remove",
    removecompany: "Remove Company",
    searchname: "Search Name...",
    searchcodenamemailph: "Search........",
    cancel: "Cancel",
    abbre: "Company Code",
    application: "Application",
    activeemployees: "Active Employees",
    numberoffiles: "Number of files",
    menu01: {},
    menu02: {},
    menu03: {},
    menu04: {},
    menu05: {},
    menu06: {},
    log: "Log",
    logid: "Log Id",
    username: "Username",
    adminstatus: "Admin status",
    coursestatus: "Course status",
    AnswerChecking: "AI Answer Checking(Subjective Test)",
    course: "Course",
    courseName: "Course Name",
    videoName: "Video Name",
    sendnoti: "Send Notification",
    apptype: "App Type",
    ip: "IP Address",
    phonemodel: "Phone Model",
    description: "Description",
    logtype: "Log Type",
    methodname: "Method Name",
    exception: "Exception",
    logtrace: "Log Trace",
    date: "Date",
    selectdate: "Select Date",
    clearsearch: "Clear Search",
    search: "Search",
    searchlogs: "Search Logs",
    report: "Report",
    company: "Company",
    noofstaff: "No Of Staff",
    oneday: "1 Day",
    twoday: "2 Days",
    threeday: "3 Days",
    fourday: "4 Days",
    oneweek: "1 Week",
    onemonth: "1 Month",
    versioncontrol: "Version Control",
    forcereset: "Force Reset",
    version: "Version",
    versionno: " Enter Version Number",
    newnnouncements: "New Announcement",
    editnnouncements: "Edit Announcement",
    announcements: "Announcements",
    detail: "Detail",
    enddate: "End Date",
    browse: "browse",
    filemustbepngonly: "File must be png, jpg, bmp only",
    post: "Post",
    uploadthumbnail: "Upload Thumbnail",
    priceplan: "Pricing Plan",
    loginOnWeb: "Login on web",
    loginOnMobile: "Login on mobile",
    checkin: "Check In",
    checkout: "Check Out",
    operationLog: "Operation Log",
    pettyCashReq: "Petty Cash Request",
    leaveReq: "Leave Request",
    enterphno:
      "Telephone number must be 10 or 11 digits.Please enter a valid phone number",
    country: "Country",
    usagereport: "Usage Report",
    companyName: "Company Name",
    leave: "Leave",
    delete: "Delete",
    updateversionno: "Update Version Number",
    usagereportbytype: "Usage Report by Type",
    usagereportbyday: "Usage Report by Day",
    export: "Export",
    exportexcel: "Export Excel",
    searchwith: "Search with log ID or Correlation ID",
    running: "Running",
    removed: "Removed",
    basicplan: "Basic Plan",
    enterpriseplan: "Enterprise Plan",
    active: "Active",
    inactive: "Inactive",
    logout: "Logout",
    from: "From",
    to: "To",
    filetype: "File Type",
    today: "Today",
    yesterday: "Yesterday",
    thisweek: "This week (Sun-Today)",
    last7days: "Last 7 days",
    lastweek: "Last week (Sun-Sat)",
    last14days: "Last 14 days",
    thismonth: "This month",
    last30days: "Last 30 days",
    lastmonth: "Last Month",
    alltime: "All time",
    doyouconfirmtoupdate: "Do you confirm to update version number to",
    wouldyouliketoreset:
      "If you would like the system to force reset for all users please fill 'Confirm' in the field below.",
    correlationid: "Correlation ID",
    ok: "OK",
    login: "Login",
    forgotpwd: "Forgot Password",
    rememberme: "Remember me",
    help: "Help",
    contacts: "Contacts",
    home: "Home",
    features: "Features",
    support: "Support",
    contact: "Contact",
    aboutus: "About Us",
    docs: "Docs",
    trybuy: "Try & Buy",
    submit: "Submit",
    sendvalidaitoncode: "Send Validation Code",
    easy: "Easy Account Set up",
    fasteasy:
      "It's fast and easy so join the growing family of Seed users and centralize your management and admin activities.",
    comreq: "Companyname is required",
    fillalpha: "Please fill in Alphabet.",
    correctemail: "Please enter correct email",
    checkinbox: "Please check your inbox for the validation code",
    emailexist: "Email already exist",
    fillnum: "Please fill in Number.",
    phrequire: "Phone Number is required.",
    abbrrequire: "Abbreviation is required",
    cityrequire: "City is required",
    countryrequire: "Country is required",
    fillalpnum: "Please fill in Alphabet or Number.",
    statusmustenable: "Status must be enabled to proceed",
    valicode: "Validation Code",
    haventreceived: "If you haven't received the validation code.",
    resend: "Resend",
    thecompanyneed:
      "The company code needs to be your company name's abbreviation. With this code, you will be able to distinguish your company's users from others. Must be English alphabets or number with a maximum of 5 characters.",
    packagename: "Package Name",
    numberoffilesupload: "Number of files uploaded",
    lastloginonweb: "Last Log in on web",
    useonwebthismonth: "Use on web this month",
    lastloginonmobile: "Last Log in on mobile",
    useonmobilethismonth: "Use on mobile this month",
    lastloginonuserview: "Last Log in on user view",
    useonuserviewthismonth: "Use on user view this month",
    numberofarticles: "Number of Articles",
    numberofsound: "Number of Sounds",
    numberofvideos: "Number of Videos",
    numberoflessonlearn: "Number of Lesson Learn",
    numberofquiztopic: "Number of Quiz topic",
    numberofevent: "Number of Event",
    numberofbanner: "Number of Banner",
    inactiveemployees: "Inactive Employees",
    expirydate: "Expiry Date",
    reminderdate: "Reminder Date",
    businesstype: "Business Type",
    otheroptionsfield: "Other options fields",
    addarticle: "Add Article",
    createdateM: "Create Date",
    articletitle: "Title",
    dragdropfile: "Drag & Drop your file here",
    orbrowsefile: "Or Browse File JPG",
    addcover: "Add Cover",
    coursemenu: "Course Menu",
    eventmenu: "Event Menu",
    recommendformatpng:
      "Recommend Format : .PNG .JPG , Resolution = 800x450 Pixel",
    recommendformatpng_announcement: "Recommended formats:",
    format: " .PNG .JPG",
    resolution: "Resolution =",
    resolutionsize: "  400x587 pixels",
    display: "Display",
    announcementdescription:
      "In cases where the announcement image is larger than 400*587 pixels, the image will be cropped to the recommended Size.",
    browsefile: "Browse File",
    recommendformatpdf: "Recommend Format : .PDF",
    additem: "Add Item",
    category: "Category",
    addCategory: "Add Category",
    selectarticle: "Select Article",
    maxsize: "Max Size",
    recommendformatmp3s:
      "Recommend Format : .MP3, Maximum upload file size : 150 MB",
    RecommendFormatMP4:
      "Recommend Format : .MP4, Maximum upload file size : 150 MB Resolution : Less than 720P",
    videotitle: "Video Title",
    edit: "Edit",
    pausesound: "Pause Sound",
    addsound: "Add Sound",
    addingsound: "Add Sound is Successful",
    editsound: "Edit Sound",
    addvideo: "Add Video",
    editvideo: "Edit Video",
    imagecover: "Image Cover",
    crpimg: "Crop Image",
    preview: "Preview",
    success: "Success",
    confirm: "Confirm",
    settingmaintenance: "Setting Maintenance",
    defaultcontent: " Default Content",
    certificate: "Certificate",
    certificatebackground: "Certificate background",
    uploaddate: "Upload date",
    numberofusers: "Number of users",
    loadingpleasewait: "Loading please wait",
    banner: "Banner",
    addbanner: "Add Banner",
    bannertitle: "Banner Title",
    actionbanner: "Action when clicking banner",
    statdatess: "Start Date",
    timesm: "Time",
    enddatess: "End Date",
    createddate: "Created Date",
    link: "Link",
    editbanner: "Edit Banner",
    addbannersuccessful: "Add Banner is Successful",
    addnew: "Add New",
    knowledgesharing: "Knowledge Sharing",
    addKnowledgeSharing: "Add Knowledge Sharing is Successful",
    addKnowledgeSharings: " Add Knowledge Sharing",
    updateKnowledgesharing: "Update Knowledge Sharing is successful",
    editknowledgesharingsuccessful: "Edit Knowledge Sharing is Successful",
    editknowledgesharing: "Edit Knowledge Sharing",
    addArticle: "Add Article is Successful",
    deleteArticle: " Delete Article is Successful",
    deletesound: "Delete Sound is Successful",
    editSound: "Update Sound is Successful",
    nodata: "No Data availabe",
    filenameL: "File Name",
    editArticle: "Edit Article is Successful",
    editarticle: "Edit Article",
    editvideos: " Edit Video is Successful",
    addingsvideo: "Add Video is Successful",
    deletesvideo: "Delete Video is Successful",
    wordcontent: "Word Content",
    createdby: "Created By",
    by: "By",
    sort: "Sort",
    viewersettingsvideo: "Viewer Settings",
    allowviewersrewindvideo: "Allow viewers to rewind",
    updatebannersuccess: "Update Banner is Successful",
    viewersettingssound: "Viewer Settings",
    allowviewersrewindsound: "Allow viewers to rewind",
    deletebanner: "Deleting Banner is Successful",
    suredelete: "Are you sure you want to delete",
    deleteconfirm: "Delete Confirmation",
    edittopicsuccessful: "Updating Category is successful",
    addtopicsuccessful: "Adding Category is successful",
    editcategory: "Edit Category",
    deletetopicsuccessful: "Deleting Category is successful",
    addcertificate: "Add Certificate",
    deletecertificate: "Delete Certificate",
    confirmsss: "Confirm",
    library: "Library"
  },
  th: {
    announcementdescription:
      "ในกรณีที่ภาพประกาศมีขนาดใหญ่กว่า 400*587 พิกเซล รูปภาพจะถูกครอบตัดตามขนาดที่แนะนำ",
    display: "แสดง",
    resolution: "ความละเอียด =",
    resolutionsize: "400x587 พิกเซล",
    recommendformatpng_announcement: "รูปแบบที่แนะนำ:",
    linkurl: "ลิงก์ URL",
    createdate: "วันที่สร้าง",
    enterbusiness: "กรุณากรอกประเภทธุรกิจของคุณ",
    searchEmpIDFullEmailPosition: "ค้นหา........",
    searchcompanyname: "ค้นหาชื่อ บริษัท",
    CompanyAddressRequired: "กรุณากรอกที่อยู่บริษัท",
    Emailrequired: "ต้องการอีเมล์",
    CompanyAddress: "ที่อยู่ บริษัท",
    CompanyTelephoneNo: "เบอร์โทรของบริษัท",
    searchnameusername: "ค้นหาชื่อ บริษัท / ชื่อผู้ใช้",
    companyNotChecked: "บริษัท ไม่ได้เช็คอินเป็นเวลาหนึ่งเดือนขึ้นไป",
    lastCheckInDate: "วันที่เช็คอินครั้งล่าสุด",
    numberofStaff: "จำนวนพนักงาน",
    CheckInReport: "เช็คอินรายงาน",
    CheckInTime: "เวลาเช็คอิน",
    CheckInUID: "เช็คอิน UID",
    CheckInDeviceModel: "ตรวจสอบรุ่นอุปกรณ์",
    CheckOutTime: "เวลาเช็คเอาต์",
    CheckOutUID: "ตรวจสอบ UID",
    CheckOutDeviceModel: "ตรวจสอบรุ่นอุปกรณ์",
    AbnormalReport: "รายงานที่ผิดปกติ",
    company_status: "สถานะ บริษัท",
    all_version: "ทุกรุ่น",
    Version_Release: "รุ่นและรุ่น",
    enterphno:
      "หมายเลขโทรศัพท์จะต้องเป็น 9 ถึง 11 หลักโปรดป้อนหมายเลขโทรศัพท์ที่ถูกต้อง",
    addemployee: "พนักงานใหม่",
    usermanagement: "การจัดการผู้ใช้งาน",
    store: "เก็บ",
    article: "บทความ​",
    video: "วีดีโอ",
    sound: "เสียง",
    companymanagement: "การจัดการ บริษัท",
    removeannouncement: "ลบประกาศ",
    doyouwanttoremovethisannouncement: "คุณต้องการลบการประกาศนี้หรือไม่?",
    newcompany: "บริษัทใหม่",
    editcompany: "แก้ไข บริษัท",
    companyname: "ชื่อบริษัท​",
    companyName: "ชื่อบริษัท​",
    totalEmployee: "พนักงานทั้งหมด",
    registrationDate: "วันที่ลงทะเบียน",
    telephoneno: "หมายเลขโทรศัพท์​",
    generalinformation: "ข้อมูลทั่วไป",
    account: "Account",
    admin: "ผู้ดูแลระบบ",
    announcement: "ประกาศ",
    addannouncement: "เพิ่มประกาศ",
    editannouncement: "แก้ไขประกาศ",
    showannouncement: "แสดงประกาศ",
    startdatetime: "วันที่เริ่มต้น เวลา",
    enddatetime: "วันที่สิ้นสุด เวลา",
    // country: "ประเทศ",
    RegistrationHL: "ลงทะเบียนเพื่อทดลองการใช้งานฟรี!!​",
    RegistrationHR: "เริ่มต้นง่าย ติดตั้งง่าย",
    RegistrationBL: "**กรุณากรอกให้ครบทุกช่องเพื่อสมัครใช้บริการ",
    RegisterCompanyCode:
      "ชื่อย่อบริษัทหรือรหัสบริษัท (ภาษาอังกฤษหรือตัวเลขที่ไม่เกิน 5 ตัวอักษร เช่น KM001)",
    RegisterButton: "ลงทะเบียน",
    IsRequired: "ต้องระบุ",
    IsNumber: "กรุณากรอกหมายเลข.",
    IsAlphabet: "กรุณากรอกตัวอักษร.",
    IsNumberAlaphabet: "กรุณากรอกตัวอักษรหรือตัวเลข",
    EnterCorrect: "กรุณากรอกอีเมล​",
    AlreadyExit: "มีอยู่แล้ว",
    RegisterSuccessful: "การลงทะเบียนสำเร็จ",
    needcompanyname: "กรุณากรอกชื่อบริษัท",
    needcompanycode: "กรุณากรอกรหัสบริษัท",
    needTel: "กรุณากรอกหมายเลขโทรศัพท์",
    needemail: "ต้องการอีเมล์",
    needcity: "ต้องการเมือง",
    needcountry: "กรุณากรอกชื่อประเทศ",
    needaddress: " ต้องการที่อยู่บริษัท",
    city: "จังหวัด",
    contactname: "ชื่อผู้ติดต่อใช้งาน",
    needcontactname: "กรุณากรอกชื่อผู้ติดต่อใช้งาน",
    address: "ที่อยู่บริษัท",
    reset: "รีเซ็ต",
    save: "บันทึก",
    type: "ชนิด",
    update: "ปรับปรุง",
    status: "สถานะ",
    newemployee: "พนักงานใหม่",
    editemployee: "แก้ไขพนักงาน",
    employeeinformation: "ข้อมูลพนักงาน",
    employeeid: "รหัสพนักงาน",
    profilepicture: "รูปประวัติ",
    companyid: "รหัส บริษัท",
    fullname: "ชื่อ",
    email: "อีเมล",
    position: "ตำแหน่ง",
    role: "หน้าที่",
    userid: "รหัสพนักงาน",
    password: "รหัสผ่าน",
    userinformation: "ข้อมูลผู้ใช้งาน",
    resetpassword: "รีเซ็ตรหัสผ่าน",
    doyouwanttoremovethisemployee: "คุณต้องการลบพนักงานคนนี้หรือไม่?",
    doyouwanttoremovethiscompany: "คุณต้องการลบ บริษัท นี้หรือไม่?",
    removeemployee: "ลบพนักงาน",
    close: "ปิด",
    remove: "เอาออก",
    searchname: "ค้นหาชื่อ ...",
    searchcodenamemailph: "ค้นหา........",
    removecompany: "ลบ บริษัท",
    cancel: "ยกเลิก",
    abbre: "รหัสบริษัท",
    action: "หนังบู๊",
    application: "ใบสมัคร",
    menu01: {},
    menu02: {},
    menu03: {},
    menu04: {},
    menu05: {},
    menu06: {},
    log: "เข้าสู่ระบบ",
    logid: "รหัสบันทึก",
    username: "ชื่อผู้ใช้งาน",
    apptype: "AppType",
    ip: "ที่อยู่ IP",
    phonemodel: "รุ่นโทรศัพท์",
    description: "ลักษณะ",
    logtype: "ประเภทบันทึก",
    methodname: "ชื่อวิธีการ",
    exception: "ข้อยกเว้น",
    logtrace: "ติดตาม",
    date: "วันที่",
    selectdate: "วันที่เลือก",
    clearsearch: "",
    search: "ค้นหา",
    searchlogs: "ค้นหาบันทึก",
    report: "รายงาน",
    company: "บริษัท",
    noofstaff: "จำนวนพนักงาน",
    oneday: "วันหนึ่ง",
    twoday: "สองวัน",
    threeday: "สามวัน",
    fourday: "สี่วัน",
    oneweek: "หนึ่งอาทิตย์",
    onemonth: "หนึ่งเดือน",
    versioncontrol: "การควบคุมเวอร์ชัน",
    forceresetforcereset: "กำลังรีเซ็ต",
    version: "เวอร์ชั่น",
    versionno: " ป้อนหมายเลขรุ่น",
    editnnouncements: "แก้ไขประกาศ",
    announcements: "ประกาศ",
    newnnouncements: "ประกาศใหม่",
    browse: "เรียกดู",
    uploadthumbnail: "",
    clear: "ชัดเจน",
    filemustbepngonly: " อัพโหลด (ไฟล์ท png,jpg,bmp เท่านั้น )",
    detail: "ข้อมูล",
    startdate: "วันเริ่มต้น",
    enddate: "วันที่เสร็จ",
    post: "ประกาศ",
    title: "หัวข้อ",
    priceplan: "แผนราคา",
    loginOnWeb: "เข้าสู่ระบบบนเว็บ",
    loginOnMobile: "เข้าสู่ระบบบนมือถือ",
    checkin: "เช็คอิน",
    checkout: "เช็คเอาท์",
    operationLog: "บันทึกการทำงาน",
    pettyCashReq: "คำขอเงินสดย่อย",
    leaveReq: "ใบลา",
    country: "ประเทศ",
    usagereport: "รายงานการใช้งาน",
    logincredentials: "บัญชีสำหรับเข้าสู่ระบบ",
    leave: "ออกจาก",
    delete: "ลบ",
    updateversionno: "อัปเดตหมายเลขเวอร์ชัน",
    usagereportbytype: "รายงานการใช้งานตามประเภท",
    usagereportbyday: "รายงานการใช้งานรายวัน",
    export: "ส่งออก",
    exportexcel: " ส่งออก Excel",
    searchwith: "ค้นหาด้วย log ID หรือ Correlation ID",
    running: "วิ่ง",
    removed: "ลบออก",
    basicplan: "แผนพื้นฐาน",
    enterpriseplan: "แผนองค์กร",
    active: "คล่องแคล่ว",
    inactive: "เฉื่อยชา",
    logout: "ออกจากระบบ",
    from: "จาก",
    to: "ถึง",
    filetype: "ประเภทไฟล์",
    today: "ในวันนี้",
    yesterday: "เมื่อวาน",
    thisweek: "สัปดาห์นี้ (วันอาทิตย์ - วันนี้)",
    last7days: "7 วันล่าสุด",
    lastweek: "สัปดาห์ที่แล้ว (Sun-Sat)",
    last14days: "14 วันล่าสุด",
    thismonth: "เดือนนี้",
    last30days: "30 วันล่าสุด",
    lastmonth: "เดือนที่แล้ว",
    alltime: "ตลอดเวลา",
    doyouconfirmtoupdate: "คุณยืนยันที่จะอัปเดตหมายเลขเวอร์ชันเป็นหรือไม่",
    wouldyouliketoreset:
      "หากคุณต้องการให้ระบบบังคับให้รีเซ็ตสำหรับผู้ใช้ทั้งหมดโปรดกรอก 'ยืนยัน' ในฟิลด์ด้านล่าง",
    correlationid: "รหัสสหสัมพันธ์",
    ok: "ตกลง",
    login: "เข้าสู่ระบบ",
    forgotpwd: "ลืมรหัสผ่าน",
    rememberme: "จดจำฉัน",
    help: "ช่วยด้วย",
    contacts: "รายชื่อผู้ติดต่อ",
    home: "หน้าแรก",
    features: "Features",
    support: "สนับสนุน",
    contact: "ติดต่อ",
    aboutus: "เกี่ยวกับเรา",
    docs: "คู่มือ",
    trybuy: "ลองและซื้อ",
    submit: "เสนอ",
    sendvalidaitoncode: "ส่งรหัสตรวจสอบ",
    easy: "ตั้งค่าบัญชีผู้ใช้ได้ง่าย",
    fasteasy:
      "มันง่ายและรวดเร็ว ดังนั้นเข้าร่วมกลุ่มผู้ใช้ Seed ที่กำลังเติบโตและรวมศูนย์การจัดการและกิจกรรมการดูแลระบบของคุณ",
    comreq: "ต้องการชื่อบริษัท",
    fillalpha: "กรุณากรอกตัวอักษร",
    correctemail: "กรุณาใส่อีเมล์ที่ถูกต้อง",
    checkinbox: "กรุณาตรวจสอบกล่องจดหมายของคุณสำหรับรหัสตรวจสอบ",
    emailexist: "อีเมลมีอยู่แล้ว",
    fillnum: "กรุณากรอกหมายเลข",
    phrequire: "กรุณากรอกหมายเลขโทรศัพท์",
    abbrrequire: "กรุณากรอกรหัสบริษัท",
    cityrequire: "กรุณากรอกจังหวัด​",
    countryrequire: "ต้องการประเทศ",
    fillalpnum: "กรุณากรอกตัวอักษรหรือตัวเลข",
    statusmustenable: "สถานะต้องเปิดใช้งานเพื่อดำเนินการต่อ",
    valicode: "รหัสตรวจสอบ",
    haventreceived: "หากคุณยังไม่ได้รับรหัสตรวจสอบ",
    resend: "ส่งซ้ำ",
    thecompanyneed:
      "รหัสบริษัทจะต้องเป็นตัวย่อของชื่อบริษัทของคุณ ด้วยรหัสนี้ คุณจะสามารถแยกความแตกต่างของผู้ใช้ของบริษัทคุณจากผู้อื่น ต้องเป็นตัวอักษรภาษาอังกฤษหรือตัวเลขที่มีความยาวสูงสุด 5 ตัวอักษร",
    activeemployees: "พนักงานประจำ",
    numberoffiles: "จำนวนไฟล์",
    packagename: "ชื่อแพ็คเกจ",
    numberoffilesupload: "จำนวนไฟล์ที่อัพโหลด",
    lastloginonweb: "เข้าสู่ระบบครั้งล่าสุดบนเว็บ",
    useonwebthismonth: "ใช้บนเว็บเดือนนี้",
    lastloginonmobile: "เข้าสู่ระบบครั้งล่าสุดบนมือถือ",
    useonmobilethismonth: "ใช้งานบนมือถือเดือนนี้",
    numberofarticles: "จำนวนบทความ",
    numberofsound: "จำนวนเสียง",
    numberofvideos: "จำนวนวิดีโอ",
    numberoflessonlearn: "จำนวนบทเรียน เรียน",
    numberofquiztopic: "จำนวนหัวข้อแบบทดสอบ",
    numberofevent: "จำนวนเหตุการณ์",
    numberofbanner: "จำนวนแบนเนอร์",
    inactiveemployees: "พนักงานที่ไม่ใช้งาน",
    expirydate: "วันหมดอายุ",
    reminderdate: "วันที่เตือนความจำ",
    businesstype: "ประเภทธุรกิจ",
    otheroptionsfield: "อื่นๆ โปรดระบุ",
    addarticle: "เพิ่มบทความ",
    createdateM: "วันที่สร้าง",
    articletitle: "ชื่อเรื่อง",
    dragdropfile: "ลากหรือวางไฟล์ของคุณที่นี่",
    orbrowsefile: "หรือเลือกไฟล์ JPG",
    AddCover: "เพิ่มรูปปก",
    recommendformatpng: "ไฟล์ภาพที่แนะนำ : PNG,JPG ความละเอียด = 800x450 Pixel",
    RecommendFormatPNG_announcement:
      "ไฟล์ภาพที่แนะนำ : PNG,JPG ความละเอียด = 400x587 Pixel",
    BrowseFile: "แนบไฟล์ PDF",
    RecommendFormatPDF: "สำหรับไฟล์ PDF เท่านั้น",
    RecommendFormatMP3: "ไฟล์ที่แนะนำ : MP3 ขนาดไฟล์อัพโหลดสูงสุด : 150 MB",
    RecommendFormatMP4:
      "ไฟล์ที่แนะนำ: MP4 ขนาดไฟล์อัพโหลดสูงสุด: 150 MB ความละเอียด: น้อยกว่า 720P",
    addsound: "เพิ่มเสียง",
    editsound: "แก้ไขเสียง",
    addvideo: "เพิ่มวิดีโอ",
    editvideo: "แก้ไขวีดีโอ",
    imagecover: "รูปปก",
    preview: "ดูตัวอย่าง",
    success: "ความสำเร็จ",
    confirm: "ยืนยัน",
    settingmaintenance: "การตั้งค่าการบำรุงรักษา"
  },
  cn: {
    announcementdescription:
      "如果公告图像大于 400*587 像素，图像将被裁剪为建议的尺寸。",
    display: "展示",
    resolution: "解决 =",
    resolutionsize: "400x587 像素",
    recommendformatpng_announcement: "推荐格式:",
    linkurl: "链接网址",
    createdate: "创建日期",
    enterbusiness: "请输入您的业务类型",
    searchEmpIDFullEmailPosition: "搜索........",
    searchcompanyname: "搜索公司名稱",
    CompanyAddressRequired: "公司地址为必填项",
    Emailrequired: "邮箱为必填项",
    CompanyAddress: "公司地址",
    CompanyTelephoneNo: "公司电话号码",
    searchnameusername: "搜索公司名稱/用戶名",
    companyNotChecked: "公司未簽到一個月或更長時間",
    lastCheckInDate: "最後入住日期",
    companyName: "公司名",
    numberofStaff: "員工人數",
    CheckInReport: "簽到報告",
    CheckInTime: "登記時間",
    CheckInUID: "簽入UID",
    CheckInDeviceModel: "簽入設備型號",
    CheckOutTime: "退房時間",
    CheckOutUID: "簽出UID",
    CheckOutDeviceModel: "檢出設備型號",
    AbnormalReport: "異常報告",
    company_status: "公司狀況",
    all_version: "所有版本",
    Version_Release: "版本和發行",
    enterphno: "電話號碼必須為9到11位數字。請輸入有效的電話號碼",
    addemployee: "新增員工",
    admin: "行政",
    announcement: "公告",
    addannouncement: "添加公告",
    editannouncement: "编辑公告",
    showannouncement: "展会公告",
    startdatetime: "开始日期时间",
    enddatetime: "结束日期时间",
    usermanagement: "用戶管理",
    store: "店铺",
    article: "文章",
    sound: "声音",
    video: "视频",
    removeannouncement: "刪除公告",
    doyouwanttoremovethisannouncement: "您要刪除此公告嗎？",
    action: "行动",
    companymanagement: "公司管理",
    newcompany: "新公司",
    editcompany: "編輯公司",
    companyname: "公司名",
    totalEmployee: "员工总数",
    registrationDate: "注册日期",
    removecompany: "刪除公司",
    telephoneno: "電話號碼",
    generalinformation: "一般信息",
    account: "Account",
    //country: "国家",
    RegistrationHL: "注册免费试用！！",
    RegistrationHR: "易于启动，易于安装 ",
    RegistrationBL: "**请填写所有必须提交的字段。",
    RegisterCompanyCode: "公司或机构简称（英文，不超过5个字符）",
    RegisterButton: "我们接受",
    IsRequired: "需要",
    IsNumber: "请填写号码。",
    IsAlphabet: "请填写字母表。",
    IsNumberAlaphabet: "请填写字母或数字。",
    EnterCorrect: "请输入正确",
    AlreadyExit: "已经存在",
    RegisterSuccessful: "注册成功",
    needcompanyname: "需要公司名称",
    needcompanycode: "需要公司代码",
    needTel: "需要公司电话号码",
    needemail: "需要邮箱",
    needcity: "需要的城市",
    needcountry: "需要的国家",
    needaddress: " 需要公司地址",
    city: "市",
    contactname: "聯繫人姓名",
    needcontactname: "需要聯繫人姓名",
    address: "地址",
    logincredentials: "登录信息",
    reset: "重啟",
    save: "救",
    update: "更新",
    status: "状态",
    newemployee: "新員工",
    editemployee: "編輯員工",
    employeeinformation: "員工信息",
    employeeid: "員工ID",
    profilepicture: "个人资料图片",
    companyid: "公司编号",
    fullname: "全名",
    email: "电子邮件",
    position: "位置",
    role: "角色",
    userid: "用戶身份",
    password: "密碼",
    userinformation: "用戶信息",
    resetpassword: "重設密碼",
    type: "類型",
    doyouwanttoremovethisemployee: "您要刪除此員工嗎？",
    doyouwanttoremovethiscompany: "您要刪除這家公司嗎？",
    removeemployee: "罷免員工",
    close: "關",
    remove: "去掉",
    searchname: "搜索名稱...",
    searchcodenamemailph: "搜索........",
    cancel: "取消",
    abbre: "公司代码",
    log: "日誌",
    logid: "日誌ID",
    username: "Username",
    adminstatus: "Admin status",
    coursestatus: "Course status",
    AnswerChecking: "AI Answer Checking(Subjective Test)",
    sendnoti: "Send Notification",
    apptype: "AppType",
    ip: "IP地址",
    phonemodel: "手机型号",
    description: "描述",
    logtype: "日志类型",
    methodname: "方法名称",
    exception: "例外",
    logtrace: "跟踪",
    setting: "設置",
    date: "日期",
    selectdate: "選擇日期",
    clearsearch: "清除搜索",
    search: "搜索",
    searchlogs: "搜索日誌",
    report: "報告",
    company: "公司",
    noofstaff: "員工人數",
    oneday: "一天",
    twoday: "二天",
    threeday: "二天",
    fourday: "四天",
    oneweek: "一周",
    onemonth: "一个月",
    versioncontrol: "版本控制",
    versionno: "输入版本號",
    forcereset: "強制重置",
    version: "版",
    newnnouncements: "新公告",
    editnnouncements: "編輯公告",
    announcements: "公告內容",
    title: "標題",
    detail: "詳情",
    startdate: "開始日期",
    enddate: "結束日期",
    browse: "瀏覽",
    application: "應用",
    filemustbepngonly: "文件只能是png,jpg,bmp",
    uploadthumbnail: "上載縮圖",
    clear: "明確",
    post: "發布",
    priceplan: "價格計劃",
    loginOnWeb: "上网登录",
    loginOnMobile: "在手机上登录",
    checkin: "报到",
    checkout: "查看",
    operationLog: "操作日志",
    pettyCashReq: "零用金要求",
    leaveReq: "休假申请",
    usagereport: "使用情况报告",
    leave: "离开",
    delete: "删除",
    updateversionno: "更新版本号",
    usagereportbytype: "使用情况报告按类型",
    usagereportbyday: "每天使用情况报告",
    export: "出口",
    exportexcel: "汇出Excel",
    searchwith: "使用日志ID或相关ID搜索",
    running: "跑步",
    removed: "已移除",
    basicplan: "基本计划",
    enterpriseplan: "企业计划",
    active: "活性",
    inactive: "不活跃",
    logout: "登出",
    from: "从",
    to: "至",
    filetype: "文件类型",
    today: "今天",
    yesterday: "昨天",
    thisweek: "本周（周日至周日）",
    last7days: "最近7天",
    lastweek: "上周（周日至周六）",
    last14days: "最近14天",
    thismonth: "这个月",
    last30days: "最近30天",
    lastmonth: "上个月",
    alltime: "整天",
    doyouconfirmtoupdate: "您是否确认将版本号更新为",
    wouldyouliketoreset:
      "如果您希望系统对所有用户强制重置，请在下面的字段中填写“确认”。",
    correlationid: "相关ID",
    ok: "好",
    login: "登录",
    forgotpwd: "忘記密碼",
    rememberme: "記住賬號",
    help: "救命",
    contacts: "联络人",
    home: "首页",
    features: "特征",
    support: "支持",
    contact: "联系",
    aboutus: "关于我们",
    docs: "文件",
    trybuy: "尝试购买",
    submit: "提交",
    sendvalidaitoncode: "发送验证码",
    easy: "简易帐户设置",
    fasteasy:
      "它既快速又容易，因此请加入不断增长的Seed用户家族，并集中管理和管理活动。",
    comreq: "公司名称为必填项",
    fillalpha: "请填写字母。",
    correctemail: "请输入正确的电子邮件",
    checkinbox: "请检查您的收件箱以获取验证码",
    emailexist: "电子邮件已经存在",
    fillnum: "请填写数字。",
    phrequire: "必须提供公司电话号码",
    abbrrequire: "必须填写公司代码",
    cityrequire: "必须填写城市",
    countryrequire: "国家为必填项",
    fillalpnum: "请填写字母或数字。",
    statusmustenable: "必须启用状态才能继续",
    valicode: "验证码",
    haventreceived: "如果您尚未收到验证码。",
    resend: "重新发送",
    thecompanyneed:
      "公司代码必须是您公司名称的缩写。使用此代码，您将能够将您公司的用户与其他用户区分开。必须是英文字母或数字，最多5个字符。",
    activeemployees: "活跃员工",
    numberoffiles: "文件数",
    packagename: "包裹名字",
    numberoffilesupload: "上传的文件数",
    lastloginonweb: "上次登录网络",
    useonwebthismonth: "本月在网络上使用",
    lastloginonmobile: "上次在手机上登录",
    useonmobilethismonth: "本月在手机上使用",
    numberofarticles: "文章数",
    numberofsound: "声音数量",
    numberofvideos: "视频数量",
    numberoflessonlearn: "学习课数",
    numberofquiztopic: "测验题目数",
    numberofevent: "事件数",
    numberofbanner: "横幅数量",
    inactiveemployees: "不活跃的员工",
    expirydate: "到期日",
    reminderdate: "提醒日期",
    businesstype: "业务类型",
    otheroptionsfield: "其他选项字段",
    addarticle: "添加文章",
    createdateM: "创建日期",
    articletitle: "标题",
    dragdropfile: "將您的文件拖放到此處",
    recommendformatpng: "推薦格式：.PNG .JPG， 分辨率 = 800x450 像素",
    RecommendFormatPNG_announcement:
      "推薦格式：.PNG .JPG， 分辨率 = 400x587 像素",
    BrowseFile: "瀏覽文件",
    RecommendFormatPDF: "推薦格式：.PDF",
    RecommendFormatMP3: "推薦格式：.MP3，最大上傳文件大小：150 MB",
    AddCategory: "添加類別",
    RecommendFormatMP4:
      "推薦格式：.MP4，最大上傳文件大小：150 MB 分辨率：小於 720P",
    addsound: "添加声音",
    editsound: "编辑声音",
    addvideo: "添加视频",
    editvideo: "编辑视频",
    imagecover: "圖片封面",
    preview: "预习",
    success: "成功",
    confirm: "确认",
    settingmaintenance: "设定保养"
  },
  vn: {
    announcementdescription:
      "Trong trường hợp hình ảnh thông báo lớn hơn 400*587 pixel, hình ảnh sẽ bị cắt theo Kích thước khuyến nghị.",
    display: "Trưng bày",
    resolution: " Nghị quyết=",
    resolutionsize: "400x587 điểm ảnh",
    recommendformatpng_announcement: "Các định dạng được đề xuất:",
    linkurl: "URL liên kết",
    createdate: "Tạo ngày",
    enterbusiness: "Vui lòng nhập loại hình kinh doanh của bạn",
    searchEmpIDFullEmailPosition: "Tìm kiếm ........",
    searchcompanyname: "tìm kiếm tên công ty",
    CompanyAddressRequired: "Địa chỉ công ty được yêu cầu",
    Emailrequired: "Email được yêu cầu",
    CompanyAddress: "Địa chỉ công ty",
    CompanyTelephoneNo: "Số điện thoại công ty",
    searchnameusername: "Tìm kiếm tên công ty / tên người dùng",
    companyNotChecked: "công ty không đăng ký trong một tháng trở lên",
    lastCheckInDate: "Ngày nhận phòng cuối cùng",
    companyName: "Tên công ty",
    numberofStaff: "số lượng nhân viên",
    CheckInReport: "Kiểm tra báo cáo",
    CheckInTime: "Kiểm tra trong thời gian",
    CheckInUID: "Đăng ký UID",
    CheckInDeviceModel: "Kiểm tra mô hình thiết bị",
    CheckOutTime: "Kiểm tra thời gian",
    CheckOutUID: "Kiểm tra UID",
    CheckOutDeviceModel: "Kiểm tra mô hình thiết bị",
    AbnormalReport: "Báo cáo bất thường...",
    company_status: "Tình trạng công ty ",
    all_version: "Tất cả các phiên bản",
    Version_Release: "Phiên bản và phát hành",
    enterphno:
      "Số điện thoại phải có từ 9 đến 11 chữ số. Vui lòng nhập số điện thoại hợp lệ",
    addemployee: "Thêm nhân viên",
    admin: "Quản trị viên",
    announcement: "Thông báo",
    addannouncement: "Thêm thông báo",
    editannouncement: "Chỉnh sửa thông báo",
    showannouncement: "Hiển thị thông báo",
    startdatetime: "Ngày bắt đầu Thời gian",
    enddatetime: "Ngày kết thúc Thời gian",
    usermanagement: "quản lý người dùng",
    store: "Cửa hàng",
    article: "Bài báo",
    sound: "Âm thanh",
    video: "Băng hình",
    action: "hoạt động",
    companymanagement: "quản lý công ty",
    removeannouncement: "Xóa thông báo",
    doyouwanttoremovethisannouncement: "Bạn có muốn xóa thông báo này?",
    newcompany: "công ty mới",
    editcompany: "chỉnh sửa công ty",
    companyname: "Tên công ty",
    totalEmployee: "Tổng số nhân viên",
    registrationDate: "ngày đăng kí",
    removecompany: "loại bỏ công ty",
    telephoneno: "Số điện thoại",
    generalinformation: "Thông tin cơ bản",
    account: "Account",
    logincredentials: "thông tin đăng nhập",
    //country: "Quốc gia",
    RegistrationHL: "Đăng ký dùng thử miễn phí!!",
    RegistrationHR: "Dễ bắt đầu, dễ cài đặt ",
    RegistrationBL: "** Vui lòng điền vào tất cả các trường phải được gửi.",
    RegisterCompanyCode:
      "Tên viết tắt của công ty hoặc đại lý (bằng tiếng Anh, không quá 5 ký tự)",
    RegisterButton: "chúng tôi đồng ý",
    IsRequired: "là cần thiết",
    IsNumber: "Vui lòng điền vào Số",
    IsAlphabet: "Vui lòng điền vào Bảng chữ cái.",
    IsNumberAlaphabet: "Vui lòng điền vào Bảng chữ cái hoặc Số.",
    EnterCorrect: "Vui lòng nhập chính xác",
    AlreadyExit: "đã tồn tại",
    RegisterSuccessful: "Đăng ký thành công",
    needcompanyname: "Cần số điện thoại của công ty",
    needcompanycode: "Cần Email",
    needTel: "thành phố cần",
    needemail: "Cần Email",
    needcity: "thành phố cần",
    needcountry: "quốc gia cần",
    needaddress: " Cần địa chỉ công ty",
    city: "Thành phố",
    contactname: "tên Liên lạc",
    needcontactname: "cần tên liên hệ",
    address: "địa chỉ nhà",
    reset: "cài lại",
    save: "lưu lại",
    update: "cập nhật",
    status: "Tình trạng",
    newemployee: "nhân viên mới",
    editemployee: "chỉnh sửa nhân viên",
    employeeinformation: "thông tin nhân viên",
    employeeid: "Mã hiệu công nhân",
    profilepicture: "Ảnh đại diện",
    companyid: "ID công ty",
    fullname: "Họ và tên",
    email: "Email",
    position: "Chức vụ",
    role: "vai trò",
    userid: "Tên người dùng",
    password: "mật khẩu",
    userinformation: "Thông tin người dùng",
    resetpassword: "đặt lại mật khẩu",
    doyouwanttoremovethisemployee: "Bạn có muốn loại bỏ nhân viên này?",
    doyouwanttoremovethiscompany: "Bạn có muốn loại bỏ công ty này?",
    removeemployee: "loại bỏ nhân viên",
    close: "đóng",
    remove: "tẩy",
    type: "kiểu",
    searchname: "tim kiêm tên...",
    searchcodenamemailph: "Tìm kiếm........",
    cancel: "hủy bỏ",
    abbre: "Mã công ty",
    log: "đăng nhập",
    logid: "ID đăng nhập",
    username: "Username",
    adminstatus: "Admin status",
    coursestatus: "Course status",
    AnswerChecking: "AI Answer Checking(Subjective Test)",
    sendnoti: "Send Notification",
    apptype: "AppType",
    ip: "Địa chỉ IP",
    phonemodel: "Mẫu điện thoại",
    description: "Sự miêu tả",
    logtype: "Loại nhật ký",
    methodname: "Tên phương thức",
    exception: "ngoại lệ",
    logtrace: "Dấu vết",
    date: "ngày",
    selectdate: "chọn ngày",
    clearsearch: "tìm kiếm rõ ràng",
    search: "Tìm kiếm",
    searchlogs: "nhật ký tìm kiếm",
    report: "báo cáo",
    company: "Công ty",
    noofstaff: "số lượng nhân viên",
    oneday: "một ngày",
    twoday: "hai ngày",
    threeday: "ba ngày",
    application: "Ứng dụng",
    fourday: "bốn ngày",
    oneweek: "một tuần",
    onemonth: "mot thang",
    versioncontrol: "kiểm soát phiên bản",
    versionno: "Đi vào số phiên bản",
    forcereset: "buộc thiết lập lại",
    version: "phiên bản",
    newnnouncements: "Thông báo mới",
    editnnouncements: "Chỉnh sửa thông báo",
    announcements: "Thông báo",
    title: "tiêu đề",
    detail: "chi tiết",
    startdate: "ngày bắt đầu",
    enddate: "ngày cuối",
    browse: "duyệt",
    filemustbepngonly: "tập tin phải là png,jpg,bmp",
    filemustbepngonly1: "tập tin phải là png",
    uploadthumbnail: "Tải lên hình thu nhỏ",
    clear: "thông thoáng",
    post: "bài đăng",
    priceplan: "Bảng giá",
    loginOnWeb: "Đăng nhập trên web",
    loginOnMobile: "Đăng nhập trên điện thoại di động",
    checkin: "Đăng ký vào",
    checkout: "Thủ tục thanh toán",
    operationLog: "Nhật ký hoạt động",
    pettyCashReq: "Yêu cầu tiền mặt nhỏ",
    leaveReq: "Yêu cầu nghỉ việc",
    country: "Quốc gia",
    usagereport: "Báo cáo sử dụng",
    leave: "rời khỏi",
    delete: "xóa bỏ",
    updateversionno: "Cập nhật số phiên bản",
    usagereportbytype: "Báo cáo sử dụng theo loại",
    usagereportbyday: "báo cáo sử dụng theo ngày",
    export: "xuất khẩu",
    exportexcel: "Xuất Excel",
    searchwith: "Tìm kiếm với ID nhật ký hoặc ID tương quan",
    running: "Đang chạy",
    removed: "Đã xóa",
    basicplan: "Kế hoạch cơ bản",
    enterpriseplan: "Kế hoạch doanh nghiệp",
    active: "Hoạt động",
    inactive: "Không hoạt động",
    logout: "Đăng xuất",
    from: "từ",
    to: "đến",
    filetype: "loại tệp",
    today: "hôm nay",
    yesterday: "Hôm qua",
    thisweek: "Tuần này (CN-Hôm nay)",
    last7days: "7 ngày qua",
    lastweek: "Tuần trước (CN-Sat)",
    last14days: "14 ngày qua",
    thismonth: "Tháng này",
    last30days: "30 ngày trước",
    lastmonth: "Tháng trước",
    alltime: "Mọi lúc",
    doyouconfirmtoupdate: "Bạn có xác nhận cập nhật số phiên bản lên",
    wouldyouliketoreset:
      "Nếu bạn muốn hệ thống buộc thiết lập lại cho tất cả người dùng, vui lòng điền 'Xác nhận' vào trường bên dưới.",
    correlationid: "ID tương quan",
    ok: "đồng ý",
    login: "Đăng nhập",
    forgotpwd: "Quên mật khẩu",
    rememberme: "nhớ tôi",
    help: "Cứu giúp",
    contacts: "Liên lạc",
    home: "Trang chủ",
    features: "Tính năng",
    support: "Hỗ trợ",
    contact: "Liên hệ",
    aboutus: "Về chúng tôi",
    docs: "Tài Liệu",
    trybuy: "Dùng thử và mua",
    submit: "Gửi đi",
    sendvalidaitoncode: "Gửi mã xác nhận",
    easy: "Thiết lập tài khoản dễ dàng",
    fasteasy:
      "Thật dễ dàng và nhanh chóng để tham gia vào cộng đồng người dùng Seed, đã và đang phát triển tập trung vào các hoạt động quản lý của bạn",
    comreq: "Tên công ty được yêu cầu",
    fillalpha: "Vui lòng điền vào Bảng chữ cái.",
    correctemail: "Vui lòng nhập đúng email",
    checkinbox: "Vui lòng kiểm tra hộp thư của bạn để nhận mã xác nhận",
    emailexist: "Email đã tồn tại",
    fillnum: "Vui lòng điền vào Số.",
    phrequire: "Số điện thoại công ty được yêu cầu",
    abbrrequire: "Mã công ty được yêu cầu",
    cityrequire: "Thành phố được yêu cầu",
    countryrequire: "Quốc gia được yêu cầu",
    fillalpnum: "Vui lòng điền vào Bảng chữ cái hoặc Số.",
    statusmustenable: "Tình trạng phải được kích hoạt để tiến hành",
    valicode: "Mã xác nhận",
    haventreceived: "Nếu bạn chưa nhận được mã xác thực.",
    resend: "Gửi lại",
    thecompanyneed:
      "Mã công ty nên là tên viết tắt của công ty bạn. Với mã này, bạn có thể phan biệt người dùng của công ty bạn với công ty khác. Nó phải thuộc bảng chữ cái tiếng Anh hoặc số có tối đa 5 ký tự.",
    activeemployees: "Nhân viên tích cực",
    numberoffiles: "Số lượng tệp",
    packagename: "Tên gói hàng",
    numberoffilesupload: "Số lượng tệp đã tải lên",
    lastloginonweb: "Lần đăng nhập cuối cùng vào mạng",
    useonwebthismonth: "Sử dụng trên web trong tháng này",
    lastloginonmobile: "Lần đăng nhập cuối cùng trên điện thoại di động",
    useonmobilethismonth: "Sử dụng trên thiết bị di động trong tháng này",
    numberofarticles: "Số lượng bài báo",
    numberofsound: "Số lượng âm thanh",
    numberofvideos: "Số lượng video",
    numberoflessonlearn: "Số tiết học",
    numberofquiztopic: "Số lượng chủ đề câu đố",
    numberofevent: "Số lượng sự kiện",
    numberofbanner: "Số lượng biểu ngữ",
    inactiveemployees: "Nhân viên không hoạt động",
    expirydate: "Ngày hết hạn",
    reminderdate: "Ngày nhắc nhở",
    businesstype: "Loại hình kinh doanh",
    otheroptionsfield: "Các trường tùy chọn khác",
    addarticle: "Thêm bài viết",
    createdateM: "Tạo ngày",
    articletitle: "Tiêu đề",
    dragdropfile: "Kéo và thả tệp của bạn vào đây",
    recommendformatpng:
      "Đề xuất Định dạng : .PNG .JPG , Độ phân giải = 800x450 Pixel",
    RecommendFormatPNG_announcement:
      "Đề xuất Định dạng : .PNG .JPG , Độ phân giải = 400x587 Pixel",
    BrowseFile: "Chọn thư mục",
    RecommendFormatPDF: "Định dạng đề xuất: .PDF",
    RecommendFormatMP3:
      "Định dạng đề xuất : .MP3, Kích thước tệp tải lên tối đa : 150 MB",
    AddCategory: "thêm thể loại",
    RecommendFormatMP4:
      "Định dạng đề xuất : .MP4, Kích thước tệp tải lên tối đa : 150 MB Độ phân giải : Dưới 720P",
    addsound: "Thêm âm thanh",
    editsound: "Chỉnh sửa âm thanh",
    addvideo: "Thêm video",
    editvideo: "Chỉnh sửa video",
    imagecover: "Ảnh bìa",
    preview: "Xem trước",
    success: "Sự thành công",
    confirm: "Xác nhận",
    settingmaintenance: "Cài đặt bảo trì"
  },
  mm: {
    announcementdescription:
      "ကြေငြာပုံသည် 400*587 pixels ထက်ကြီးသောကိစ္စများတွင်၊ ပုံအား အကြံပြုထားသောအရွယ်အစားသို့ ဖြတ်တောက်မည်ဖြစ်သည်။",
    display: "ပြသခြင်း။",
    resolution: " ပြတ်သားမှု=",
    resolutionsize: " ၄၀၀x၅၈၇ ပစ်ဇယ်",
    recommendformatpng_announcement: "အကြံပြုထားသော ဖော်မတ်များ",
    linkurl: "လင့်ခ် URL",
    createdate: "ရက်စွဲဖန်တီးပါ။",
    enterbusiness: "သင့်လုပ်ငန်းအမျိုးအစားကို ထည့်သွင်းပါ။",
    searchEmpIDFullEmailPosition: "ရှာဖွေပါ........",
    searchcompanyname: "ကုမ္ပဏီအမည်ရှာပါ",
    CompanyAddressRequired: "ကုမ္ပဏီလိပ်စာလိုအပ်သည်",
    Emailrequired: "အီးမေးလ်လိုအပ်ပါသည်",
    CompanyAddress: "ကုမ္ပဏီလိပ်စာ",
    CompanyTelephoneNo: "ကုမ္ပဏီတယ်လီဖုန်းနံပါတ်",
    searchnameusername: "ကုမ္ပဏီအမည် / အသုံးပြုသူအမည်ရှာဖွေပါ",
    companyNotChecked: "တစ်လသို့မဟုတ်ထိုထက်ပိုသော မှတ်ပုံတင်မထားသောကုမ္ပဏီ",
    lastCheckInDate: "နောက်ဆုံးသွင်းသည့်နေ့စွဲ",
    companyName: "ကုမ္ပဏီအမည်",
    numberofStaff: "ဝန်ထမ်းအရေအတွက်",
    CheckInReport: "အစီရင်ခံစာ",
    CheckInTime: "အချိန်စစ်ဆေးပါ",
    CheckInUID: "UID ကိုစစ်ဆေးပါ",
    CheckInDeviceModel: "ကိရိယာပုံစံကိုစစ်ဆေးပါ",
    CheckOutTime: "အချိန်ထွက်စစ်ဆေးပါ",
    CheckOutUID: "UID ကိုထုတ်စစ်ဆေးပါ",
    CheckOutDeviceModel: "Device Model ကိုစစ်ဆေးပါ",
    AbnormalReport: "ပုံမှန်မဟုတ်သောအစီရင်ခံစာ",
    company_status: "ကုမ္ပဏီအခြေအနေ",
    all_version: "ဗားရှင်းအားလုံး",
    Version_Release: "ဗားရှင်းနှင့်ဖြန့်ချိ",
    enterphno:
      "တယ်လီဖုန်းနံပါတ်သည် ၉လုံး မှ ၁၁ လုံးဖြစ်သင့်သည် မှန်ကန်သောဖုန်းနံပါတ်ကိုထည့်ပါ",
    addemployee: "ဝန်ထမ်းထည့်ပါ",
    admin: "အက်မင်",
    announcement: "ကြေညာချက်များ",
    addannouncement: "ကြေငြာချက်များထည့်ပါ",
    editannouncement: "ကြေငြာချက်များကို တည်းဖြတ်ပါ",
    showannouncement: "ကြေငြာချက်ပြပါ",
    startdatetime: "စတင်ရက်စွဲအချိန်",
    enddatetime: "ကုန်ဆုံးရက်စွဲအချိန်",
    usermanagement: "အသုံးပြုသူစီမံခန့်ခွဲမှု",
    store: "စတိုး",
    article: "ဆောင်းပါး",
    sound: "သီချင်း",
    video: "ဗီဒီယို",
    removeannouncement: "ကြေငြာချက်ဖယ်ရှားခြင်း",
    doyouwanttoremovethisannouncement: "ဒီကြေညာချက်ကိုဖျက်ချင်ပါသလား?",
    action: "လုပ်ဆောင်ခြင်း",
    companymanagement: "ကုမ္ပဏီစီမံခန့်ခွဲမှု",
    newcompany: "ကုမ္ပဏီအသစ်",
    removecompany: "ကုမ္ပဏီ ဖယ်ရှားခြင်း",
    editcompany: "ကုမ္ပဏီအချက်အလက်များ ပြင်ဆင်ခြင်း",
    logincredentials: "ဝင်ခွင့်အထောက်အထားများ",
    companyname: "ကုမ္ပဏီအမည်",
    totalEmployee: "စုစုပေါင်းဝန်ထမ်း",
    registrationDate: "မှတ်ပုံတင်ရက်စွဲ",
    telephoneno: "တယ်လီဖုန်းနံပါတ်",
    generalinformation: "ယေဘုယျသတင်းအချက်အလက်",
    account: "Account",
    //country: "နိုင်ငံ",
    RegistrationHL: "အခမဲ့အစမ်းသုံးရန် စာရင်းသွင်းပါ။!!",
    RegistrationHR: "စတင်ရန်လွယ်ကူပြီး install လုပ်ရန်လည်းလွယ်ကူသည်",
    RegistrationBL: "** တင်သွင်းရမည့်နေရာအားလုံးကိုဖြည့်ပါ။",
    RegisterCompanyCode:
      "ကုမ္ပဏီသို့မဟုတ်အေဂျင်စီအတိုကောက် (အင်္ဂလိပ်ဘာသာဖြင့်၊ စာလုံးရေ ၅ လုံးထက်မက)",
    RegisterButton: "ငါတို့လက်ခံတယ်",
    IsRequired: "လိုအပ်ပါသည်",
    IsNumber: "ကျေးဇူးပြု၍ နံပါတ်ဖြည့်ပါ",
    IsAlphabet: "ကျေးဇူးပြုပြီးအက္ခရာကိုဖြည့်ပါ။",
    IsNumberAlaphabet: "ကျေးဇူးပြုပြီးအက္ခရာသို့မဟုတ်နံပါတ်ဖြည့်ပါ။",
    EnterCorrect: "ကျေးဇူးပြု၍ မှန်ကန်စွာရိုက်ထည့်ပါ",
    AlreadyExit: "ရှိပြီးသား",
    RegisterSuccessful: "မှတ်ပုံတင်ခြင်းအောင်မြင်သည်",
    needcompanyname: "ကုမ္ပဏီနာမည်လိုအပ်တယ်",
    needcompanycode: "ကုမ္ပဏီအတိုကောက်လိုအပ်သည်",
    needTel: "ကုမ္ပဏီဖုန်းနံပါတ်လိုအပ်တယ်။",
    needemail: "အီးမေးလ်လိုအပ်တယ်",
    needcity: "မြို့လိုအပ်",
    needcountry: "လိုအပ်တဲ့နိုင်ငံ",
    needaddress: " ကုမ္ပဏီလိပ်စာလိုအပ်တယ်",
    city: "မြို့",
    contactname: "ဆက်သွယ်ရန်အမည်",
    needcontactname: "ဆက်သွယ်ရန်အမည် လိုအပ်ပါတယ်",
    address: "လိပ်စာ",
    reset: "ပြန်လည်သတ်မှတ်ပါ",
    save: "သိမ်းဆည်းပါ",
    update: "မွမ်းမံ",
    status: "စတေးတပ်",
    newemployee: "၀န်ထမ်းအသစ်",
    editemployee: "ဝန်ထမ်းပြင်ဆင်ခြင်း",
    employeeinformation: "ဝန်ထမ်းအချက်အလက်",
    employeeid: "၀န်ထမ်း အိုင်ဒီ",
    profilepicture: "ပရိုဖိုင်ပုံ",
    companyid: "ကုမ္ပဏီ အိုင်ဒီ",
    fullname: "နာမည်အပြည့်အစုံ",
    email: "အီးမေးလ်",
    position: "ရာထူး",
    role: "အခန်းကဏ္ဍ",
    type: "အမျိုးအစား",
    userinformation: "အသုံးပြုသူအချက်အလက်",
    password: "စကားဝှက်",
    resetpassword: "စကားဝှက်အားမူလအတိုင်းပြန်လုပ်မည်",
    doyouwanttoremovethisemployee: "ဤ၀န်ထမ်းကိုသင်ဖယ်ရှားလိုပါသလား။",
    doyouwanttoremovethiscompany: "ကုမ္ပဏီ ဖယ်ရှားချင်ပါသလား?",
    removeemployee: "ဝန်ထမ်းဖယ်ရှားလိုက်ပါ",
    close: "ပိတ်",
    remove: "ဖယ်ရှားလိုက်ပါ",
    searchname: "နာမည်နှင့်ရှာပါ...",
    searchcodenamemailph: "ရှာဖွေပါ........",
    cancel: "ပယ်ဖျက်ပါ",
    abbre: "ကုမ္ပဏီကုဒ်",
    log: "မှတ်တမ်း",
    logid: "မှတ်တမ်း အိုင်ဒီ",
    username: "အသုံးပြုသူအမည်",
    userid: "အသုံးပြုသူ အိုင်ဒီ",
    apptype: "AppType",
    ip: "အိုင်ပီလိပ်စာ",
    phonemodel: "ဖုန်းမော်ဒယ်",
    description: "ဖော်ပြချက်",
    logtype: "စာတမ်းအမျိုးအစား",
    methodname: "နည်းလမ်းအမည်",
    exception: "ခြွင်းချက်",
    logtrace: "စာတမ်းအချက်အလက်",
    date: "ရက်စွဲ",
    selectdate: "နေ့စွဲ ရွေးချယ်ပါ",
    clearsearch: "ရှာ​ဖွေထားသည်ကို ရှင်းလင်းပါ",
    search: "ရှာ​ဖွေပါ",
    searchlogs: "မှတ်တမ်းများရှာ​ဖွေခြင်း",
    report: "အစီရင်ခံစာ",
    company: "ကုမ္ပဏီ",
    noofstaff: "ဝန်ထမ်းအရေအတွက်",
    oneday: "တစ်ရက်",
    twoday: "နှစ်ရက်",
    threeday: "သုံးရက်",
    fourday: "‌‌လေးရက်",
    oneweek: "တစ်ပတ်",
    onemonth: "တစ်လ",
    application: "လျှောက်လွှာ",
    versioncontrol: "ဗားရှင်းထိန်းချုပ်မှု",
    forcereset: "ပြန်လည်စတင်ခြင်း",
    version: "ဗားရှင်း",
    versionno: "ဗားရှင်းနံပါတ် ရိုက်ထည့်ပါ",
    newnnouncements: "ကြေညာချက်အသစ်",
    editnnouncements: "ကြေညာချက် ပြင်ဆင်ခြင်း",
    announcements: "ကြေညာချက်များ",
    title: "ခေါင်းစဥ်",
    detail: "အသေးစိတ်",
    startdate: "စတင်သည့်ရက်စွဲ",
    enddate: "အဆုံးရက်",
    browse: "ဖိုင်ဖွင့်ပါ",
    filemustbepngonly: "ဖိုင်သည် png,jpg,bmp သာဖြစ်ရမည်",
    filemustbepngonly1: "ဖိုင်သည် png သာဖြစ်ရမည်",
    uploadthumbnail: "ပုံတင်ပါ",
    post: "ပို့စ်",
    // update: "မွမ်းမံခြင်း",
    clear: "ပြန်လည်သတ်မှတ်ပါ",
    priceplan: "စျေးနှုန်းအစီအစဉ်",
    loginOnWeb: "ဝဘ်ပေါ်မှာလော့ဂ်အင်ဝင်သည်",
    loginOnMobile: "မိုဘိုင်းပေါ်မှာလော့ဂ်အင်ဝင်သည်",
    checkin: "ရောက်ရှိစာရင်း",
    checkout: "ရောက်ရှိစာရင်း",
    operationLog: "စစ်ဆင်ရေးမှတ်တမ်း",
    pettyCashReq: "အသေးသုံးငွေတောင်းခံမှု",
    leaveReq: "ခွင့်တောင်းခံမှု",
    country: "နိုင်ငံ",
    usagereport: "အသုံးပြုမှုအစီရင်ခံစာ",
    leave: "ခွင့်",
    delete: "ဖျက်မည်",
    updateversionno: "ဗားရှင်းနံပါတ်မွမ်းမံသည်",
    usagereportbytype: "အမျိုးအစားအားဖြင့်အသုံးပြုမှုအစီရင်ခံစာ",
    usagereportbyday: "တစ်နေ့တာအသုံးပြုမှုအစီရင်ခံစာ",
    // export: "အချက်အလက်များထုတ်ယူမည်",
    export: "ထုတ်ယူမည်",
    // exportexcel: "Excelဖြင့်အချက်အလက်များထုတ်ယူမည်",
    exportexcel: "ထုတ်ယူမည်",
    searchwith: "မှတ်တမ်း အိုင်ဒီ သို့မဟုတ် ဆက်စပ်မှု အိုင်ဒီ နှင့်ရှာဖွေပါ",
    running: "runနေသည်",
    removed: "ဖယ်ရှားခဲ့သည်",
    basicplan: "အခြေခံအစီအစဉ်",
    enterpriseplan: "လုပ်ငန်းအစီအစဉ်",
    active: "အက်တစ်",
    inactive: "အက်တစ်မဖြစ်",
    logout: "ထွက်သည်",
    from: "မှ",
    to: "သို့",
    filetype: "ဖိုင်အမျိုးအစား",
    today: "ဒီနေ့",
    yesterday: "မနေ့က",
    thisweek: "ယခုအပတ် (Sun-Today)",
    last7days: "နောက်ဆုံး ၇ ရက်",
    lastweek: "ပြီးခဲ့သည့်အပတ်က (Sun-Sat)",
    last14days: "နောက်ဆုံး ၁၄ ရက်",
    thismonth: "ဤလတွင်",
    last30days: "ပြီးခဲ့သည့်ရက်ပေါင်း 30",
    lastmonth: "ပြီးခဲ့သည့်လ",
    alltime: "အချိန်တိုင်း",
    doyouconfirmtoupdate: "ဗားရှင်းနံပါတ်အသစ်ပြောင်းရန်သင်အတည်ပြုပါသလား",
    wouldyouliketoreset:
      "အသုံးပြုသူများအားလုံးအတွက်ပြန်လည်စတင်ခြင်းစနစ်ကိုသင်ပြုလုပ်လိုပါကအောက်ဖော်ပြပါကွက်လပ်ရှိ 'အတည်ပြု' ကိုဖြည့်ပါ။",
    correlationid: "ဆက်စပ်မှု အိုင်ဒီ",
    ok: "အိုကေ",
    login: "လော့ဂ်အင်",
    forgotpwd: "စကားဝှက်ကိုမေ့နေပါသလား",
    rememberme: "ကျွန်ုပ်ကိုမှတ်သားထားပါ",
    help: "အကူအညီ",
    contacts: "ဆက်သွယ်ရန်",
    home: "မူလပေ့",
    features: "အင်္ဂါရပ်များ",
    support: "ပံ့ပိုးမှု",
    contact: "ဆက်သွယ်ရန်",
    aboutus: "ကိုယ်တို့အကြောင်း",
    docs: "စာရွက်စာတမ်းများ",
    trybuy: "စမ်းမည် ဝယ်မည်",
    submit: "တင်သွင်း",
    sendvalidaitoncode: "အတည်ပြုကုဒ်ပေးပို့ပါ",
    easy: "အကောင့်၀င်ရန် လွယ်ကူခြင်း",
    fasteasy:
      "Seed သုံးစွဲသူများတိုးပွားလာသောမိသားစုတွင်မြန်ဆန်လွယ်ကူသည်။ သင်၏စီမံခန့်ခွဲမှုနှင့်အုပ်ချုပ်ရေးလှုပ်ရှားမှုများကိုဗဟိုပြုပါ",
    comreq: "ကုမ္ပဏီနာမည်လိုအပ်သည်",
    fillalpha: "ကျေးဇူးပြုပြီးအက္ခရာဖြည့်ပါ",
    correctemail: "ကျေးဇူးပြု၍ မှန်ကန်သောအီးမေးလ်ကိုရေးပါ",
    checkinbox: "ကျေးဇူးပြုပြီးသင့်ရဲ့ မေးလ် ကိုအတည်ပြုခြင်းကုဒ်အတွက်စစ်ဆေးပါ",
    emailexist: "အီးမေးလ်ရှိပြီးသားဖြစ်သည်",
    fillnum: "ကျေးဇူးပြု၍ နံပါတ်ဖြည့်ပါ",
    phrequire: "ဖုန်းနံပါတ်လိုအပ်သည်",
    abbrrequire: "အတိုကောက်လိုအပ်သည်",
    cityrequire: "စီးတီးလိုအပ်သည်",
    countryrequire: "နိုင်ငံလိုအပ်သည်",
    fillalpnum: "ကျေးဇူးပြု၍ အက္ခရာသို့မဟုတ်နံပါတ်ဖြည့်ပါ",
    statusmustenable: "အခြေအနေကိုဆက်လက်လုပ်ဆောင်ရန်လိုအပ်သည်",
    valicode: "ကုဒ်",
    haventreceived: "သင်ကအတည်ပြုကုဒ်မရရှိခဲ့လျှင်",
    resend: "ပြန်လည်ပေးပို့ပါ",
    thecompanyneed:
      "ကုမ္ပဏီကုဒ်သည်သင်၏ကုမ္ပဏီအမည်အတိုကောက်ဖြစ်သင့်သည်။ ဤကုဒ်ဖြင့်သင်၏ကုမ္ပဏီအသုံးပြုသူများကိုအခြားသူများနှင့်ခွဲခြားနိုင်လိမ့်မည်။ အင်္ဂလိပ်အက္ခရာသို့မဟုတ်အများဆုံးစာလုံးရေ ၅ လုံးရှိရမည်။",
    activeemployees: "တက်ကြွသောဝန်ထမ်းများ",
    numberoffiles: "ဖိုင်အရေအတွက်",
    packagename: "Package အမျိုးအစား",
    numberoffilesupload: "တင်နိူင်သောဖိုင်အရေအတွက်",
    lastloginonweb: "ဝဘ်ပေါ်တွင်နောက်ဆုံးဝင်ရောက်မှု",
    useonwebthismonth: "ဤလတွင် ဝဘ်ပေါ်တွင် အသုံးပြုမှု",
    lastloginonmobile: "မိုဘိုင်းတွင်နောက်ဆုံးဝင်ရောက်မှု",
    useonmobilethismonth: "ယခုလတွင် မိုဘိုင်းလ်တွင် အသုံးပြုမှု",
    numberofarticles: "ဆောင်းပါးအရေအတွက်",
    numberofsound: "အသံအရေအတွက်",
    numberofvideos: "ဗီဒီယိုအရေအတွက်",
    numberoflessonlearn: "သင်ခန်းစာအရေအတွက်",
    numberofquiztopic: "ပဟေဠိအကြောင်းအရာအရေအတွက်",
    numberofevent: "ပွဲအရေအတွက်",
    numberofbanner: "နဖူးစည်းနံပါတ်",
    inactiveemployees: "အလုပ်မလုပ်သော ဝန်ထမ်းများ",
    expirydate: "သက်တမ်းကုန်ဆုံးရက်",
    reminderdate: "သတိပေးသည့်နေ့",
    businesstype: "လုပ်ငန်းအမျိုးအစားများ",
    otheroptionsfield: "အခြားရွေးချယ်စရာအကွက်များ",
    addarticle: "ဆောင်းပါးထည့်သည်",
    createdateM: "ဖန်တီးထားသောရက်စွဲ",
    articletitle: "ခေါင်းစဥ်",
    dragdropfile: "သင်၏ ဖိုင်ကို ဆွဲယူ၍ လွှတ်ချပါ။",
    recommendformatpng:
      "အကြံပြုထားသည့် ဖော်မတ်- .PNG .JPG , Resolution = 800x450 Pixel",
    RecommendFormatPNG_announcement:
      "အကြံပြုထားသည့် ဖော်မတ်- .PNG .JPG , Resolution = 400x587 Pixel",
    BrowseFile: "ဖိုင်ကိုလှန်ကြည့်ပါ။",
    RecommendFormatPDF: "ဖော်မတ်- .PDF ကို အကြံပြုပါ။",
    RecommendFormatMP3:
      "အကြံပြုထားသည့် ဖော်မတ်- .MP3၊ အများဆုံး အပ်လုဒ်ဖိုင်အရွယ်အစား- 150 MB",
    AddCategory: "အမျိုးအစားထည့်ပါ။",
    RecommendFormatMP4:
      "အကြံပြုချက် ဖော်မတ်- .MP4၊ အများဆုံး အပ်လုဒ် ဖိုင်အရွယ်အစား- 150 MB ကြည်လင်ပြတ်သားမှု- 720P အောက်",
    addsound: "သီချင်းထည့်သည်",
    editsound: "သီချင်းပြင်သည်",
    addvideo: "ဗီဒီယိုထည့်သည်",
    editvideo: "ဗီဒီယိုပြင်သည်",
    imagecover: "ရုပ်ပုံကာဗာ",
    preview: "အစမ်းကြည့်ရှုခြင်း",
    success: "အောင်မြင်သည်",
    confirm: "အတည်ပြုပါ",
    settingmaintenance: "ပြင်ဆင်ထိန်းသိမ်းခြင်း"
  }
};

const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "th", // set fallback locale
  messages // set locale messages
});
Vue.filter("myLocale", function(value) {
  return i18n.t(value);
});
export default i18n;
